import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;
function ReporteHelados(props) {
    const {loading,setLoading,regional,actualizar}=props;
    const [listaAlmacen, setListaAlmacen] = useState([]);
    const [listaTipoA, setListaTipoA] = useState([]);
    function getSumaValor(val) {
        if (listaAlmacen.length !== 0) {
            var suma = listaAlmacen.filter(item => item.ID_PRODUCTO == val).map(j => j.STOCK);
            var aux = suma.reduce((a, b) => a + b, 0);
            var num = aux;
            if (val == 102) {
                num = aux.toFixed(2)
            }
            return num
        } else {
            return 0
        }
    }
    function getInformacionHelado() {
        setLoading(true);
        fetch(`${server}/reporte/getReportePlantaHelados`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, 'ID_SUCURSAL': 14
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data.ok)
                setLoading(false);
                if (data.ok) {
                    setListaAlmacen(data.ok);
                    var almacen = data.ok.map(item => item.NOMBRE_ALMACEN);
                    var aux = new Set(almacen);
                    setListaTipoA([...aux]);
                    //setBanderaCambio(true);
                } else {
                    setLoading(false);
                    MsgUtils.msgError(data.message);
                }
            })
            .catch(error => MsgUtils.msgError(error));
    }
    useState(()=>{
        getInformacionHelado();
    },[actualizar])
    return (
        <div className='container-fluid'>
            <div className='card mb-2' style={{ minHeight: '215px' }}>
                <div className='card-header text-center'>
                    {'SANTA CRUZ'}
                </div>
                <div className='card-body'>
                    <table className="table table-stripet">
                        <thead>
                            <tr>
                                <th scope="col">Almacen</th>
                                <th scope="col">Crema Americana</th>
                                <th scope="col">Mango</th>
                                <th>Frutilla</th>
                                <th>Capuchino</th>
                                <th>Mashmello</th>
                                <th>Chicle</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listaTipoA.map((item, index) => {
                                console.log(item);
                                var aux = listaAlmacen.filter((dato) => dato.NOMBRE_ALMACEN == item).sort((a, b) => a.ID_PRODUCTO < b.ID_PRODUCTO);
                                return (
                                    <tr key={index}>
                                        <th scope="row">{aux[0].NOMBRE_ALMACEN}</th>
                                        <td className=''>{aux[0].STOCK}</td>
                                        <td className=''>{aux[1].STOCK}</td>
                                        <td className=''>{aux[2].STOCK}</td>
                                        <td className=''>{aux[3].STOCK}</td>
                                        <td className=''>{aux[4]==undefined?'-':aux[4].STOCK}</td>
                                        <td className=''>{aux[5]==undefined?'-':aux[4].STOCK}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th> Total: </th>
                                <td className='fw-bold'>{getSumaValor(110)}</td>
                                <td className='fw-bold'>{getSumaValor(112)}</td>
                                <td className='fw-bold'>{getSumaValor(113)}</td>
                                <td className='fw-bold'>{getSumaValor(114)}</td>
                                <td className='fw-bold'>{getSumaValor(2195)}</td>
                                <td className='fw-bold'>{getSumaValor(2196)}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default ReporteHelados